import React from "react"

import * as genericSectionStyles from "../styles/GenericSection.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

import WPCta from "./_base/WPCta"

export default function GenericSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `generic-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const subTitle = ChildSelector.select(
    content,
    `generic-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "generic-content")
    .map(t => t.text)

  return (
    <>
      <div
        className={`row justify-content-center ${props.className} ${genericSectionStyles.wrapper}`}
      >
        <div className={`col-12 ${genericSectionStyles.content}`}>
          {title && (
            <h1
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
          )}
          {subTitle && (
            <h4
              dangerouslySetInnerHTML={{
                __html: subTitle,
              }}
            />
          )}
          {textStack.length > 0 &&
            textStack.map((t, idx) => <p key={idx}>{t}</p>)}
          {ChildSelector.select(content, "generic-section-cta") && (
            <WPCta
              holder={content}
              selector={`generic-section-cta`}
              translate={true}
              className={`${genericSectionStyles.ctaBtn}`}
              pageContext={props.pageContext}
            />
          )}
        </div>
      </div>
    </>
  )
}
